'use memo'

import { useState } from 'react'

interface ExpandedIds {
  expandedIds: ReadonlySet<string>
  toggle: (id: string) => void
}

/**
 * Which rows are open. Independent, like the cards — opening one leaves the
 * others as they are.
 */
export const useExpandedIds = (): ExpandedIds => {
  'use memo'

  const [expandedIds, setExpandedIds] = useState<ReadonlySet<string>>(
    () => new Set()
  )

  const toggle = (id: string) =>
    setExpandedIds((current) => {
      const next = new Set(current)
      if (next.has(id)) {
        next.delete(id)
      } else {
        next.add(id)
      }
      return next
    })

  return { expandedIds, toggle }
}
